(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-alpacas-sale]').forEach((section) => {
      if (section.dataset.alpacasSaleReady === 'true') return;
      section.dataset.alpacasSaleReady = 'true';

      const filters = [...section.querySelectorAll('[data-alpaca-filter]')];
      const cards = [...section.querySelectorAll('[data-alpaca-sex]')];
      const visibleCount = section.querySelector('[data-alpacas-visible-count]');

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          const selected = filter.dataset.alpacaFilter;
          let count = 0;

          cards.forEach((card) => {
            card.hidden = selected !== 'all' && card.dataset.alpacaSex !== selected;
            if (!card.hidden) count += 1;
          });

          filters.forEach((option) => {
            option.setAttribute('aria-pressed', String(option === filter));
          });
          visibleCount.textContent = count;
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document));
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
